module.exports = __webpack_public_path__ + "img/google_fit.a10ad440.svg";